const profileData = {
  heading: "Profile:",
  points: [
    "From building technology to understanding business — I’m building the skills to create what’s next.",
    "I’m a B.Tech graduate in Computer Science & Engineering with professional experience across software development, web technologies, and IT, and I’m currently pursuing a PGDM.",
    "My experience has strengthened my skills in problem-solving, software development, data analysis, business research, communication, and adaptability. Today, I’m expanding that technical foundation into business, finance, and management, with a strong interest in FinTech and Entrepreneurship.",
    "In the near term, I aim to gain strong industry exposure and develop practical expertise at the intersection of technology, finance, and business. In the long run, I aspire to build innovative FinTech solutions and entrepreneurial ventures that solve real-world problems.",
    "Technology | Finance | Business | FinTech | Entrepreneurship",
  ],
};

export default profileData;
